<template>
    <cart-table-container class="cart-table-container">
        <LoadingApp
            :isLoading.sync="isLoading"
            :is_full_page="true"
        />
        <table class="table table-cart">
            <thead>
                <tr>
                    <th class="product-col">Produto</th>
                    <th class="price-col">Preço</th>
                    <th class="qty-col">Quantidade</th>
                    <th v-if="hasFractionalSale" style="min-width: 8rem">Peso</th>
                    <th v-if="calculateIpi">IPI</th>
                    <th>Subtotal</th>

                </tr>
            </thead>
            <tbody>
                <!-- LISTAGEM DE PRODUTOS SIMPLES -->
                <template v-for="item in itemsCart.list">
                    <template v-if="!item.is_product_group && !item.has_childs_additionals && !item.additional_product && !item.uuid_item_father_cart">
                        <tr :key="item.id+'-'+item.uuid" class="product-row">
                            {{ setBackup(item) }}
                            <td class="product-col">
                                <CartItemProduct
                                    :product="item"
                                />
                            </td>
                            <td>
                                {{ !item.price_to ? currency.money(item.pro_price_site) : currency.money(item.price_to) }}
                            </td>
                            <td>
                                <template v-if="page == 'checkout'">
                                    {{ item.qtd_cart }}
                                    <template v-if="getShowUnitOfMeasureInProductPrice">
                                        {{ item.pro_sigla_medida }}
                                    </template>
                                </template>

                                <template v-else>
                                    <c-span v-if="item.quantity_per_box && item.discount_when_selling_with_closed_box">
                                        <strong>
                                            {{ setNumberOfBoxesSelected(item) }} {{ setNumberOfBoxesSelected(item) > 1 ? 'caixas' : 'caixa' }} são {{ item.quantity_per_box * setNumberOfBoxesSelected(item) }} unidades.
                                        </strong>
                                    </c-span>
                                    <c-input-qtd style="margin: 0 auto" class="input-quantity-cart">
                                        <input
                                            type="text"
                                            v-model="item.qtd_cart"
                                            :disabled="item.quantity_per_box && item.discount_when_selling_with_closed_box ? 'disabled' : false"
                                            @blur="onBlurMinimumQuantity(item, item.qtd_cart)"
                                            autocomplete="off"
                                            name="quantity-product"
                                        >
                                        <div class="buttons-quantity-cart">
                                            <button
                                                class="btn-quantity-plus"
                                                @click="setQuantityPlus(item)"
                                            >
                                                <i class="fas fa-caret-up"></i>
                                            </button>
                                            <button
                                                class="btn-quantity-minus"
                                                @click="setQuantityMinus(item)"
                                            >
                                                <i class="fas fa-caret-down"></i>
                                            </button>
                                        </div>
                                        <span v-if="getShowUnitOfMeasureInProductPrice" style="align-self: center; margin-left: 0.5rem">
                                            {{ item.pro_sigla_medida }}
                                        </span>
                                    </c-input-qtd>
                                </template>
                            </td>
                            <td v-if="hasFractionalSale">
                                {{ item.fractional_quantity }} {{ item.fractional_label }}
                            </td>
                            <td v-if="calculateIpi">
                                {{ item.ipi_percentage == null ? '' : item.ipi_percentage + '%' }}
                            </td>
                            <td>
                                {{currency.money(calculateSubTotal(item))}}
                            </td>
                        </tr>
                        <tr v-if="page != 'checkout'" :key="item.uuid" class="product-action-row">
                            <td :colspan="5" class="clearfix">
                                <div class="float-right">
                                    <a
                                        href="#"
                                        @click.prevent.stop="removeItem(item.id, item.key_cart)"
                                        title="Remover produto"
                                        class="btn-remove"
                                    >
                                        <span class="sr-only">Remover</span>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </template>
                </template>

                <!-- LISTAGEM DE PRODUTOS DE CESTA -->
                <template v-for="(item, key) in itemsCart.father_list">
                    <tr :key="key+'-'+item.uuid" class="product-row">
                        {{ setBackup(item) }}
                        <td class="product-col">
                            <CartItemProduct
                                :product="item"
                            />
                        </td>
                        <td>
                            {{ !item.price_to ? currency.money(item.pro_price_site) : currency.money(item.price_to) }}
                        </td>
                        <td>
                            1 <template v-if="getShowUnitOfMeasureInProductPrice">{{ item.pro_sigla_medida }}</template>
                        </td>
                        <td v-if="hasFractionalSale"></td>
                        <td>
                            {{ !item.price_to ? currency.money(item.pro_price_site) : currency.money(item.price_to) }}
                        </td>
                    </tr>
                    <tr v-if="page != 'checkout'" :key="key+'-2-'+item.uuid" class="product-action-row">
                        <td :colspan="5" class="clearfix p-0">

                            <div class="float-right">
                                <a
                                    href="#"
                                    @click.prevent.stop="removeProductGroup(item.uuid, item.children)"
                                    title="Remover produto"
                                    class="btn-remove"
                                >
                                    <span class="sr-only">Remover</span>
                                </a>
                            </div>
                        </td>
                    </tr>
                    <template v-for="(child, index) in item.children">
                        <tr :key="key+'-'+index+'-'+item.uuid+'-'+child.uuid">
                            <td class="d-flex align-items-center pb-2 pt-0">
                                <figure class="product-image-container mr-4" style="min-width: 8rem; width: 8rem; margin: 0 0 0 8.4rem">
                                    <a
                                        :href="item.url_pro"
                                        class="product-image"
                                    >
                                        <vue-load-image>
                                            <img slot="image" :src="child.image_main" :title="child.pro_name_site" :alt="child.pro_name_site">
                                            <img slot="preloader" :src="$baseUrl+'assets/images/loading-image.gif'"/>
                                            <div slot="error">Erro ao carregar a imagem</div>
                                        </vue-load-image>
                                    </a>
                                </figure>
                                <span class="text-left">
                                    <h1>
                                        <a :href="item.url_pro">
                                            <template v-if="products_settings.show_code_original_beside_description == true && child.api_cod_original">{{ child.api_cod_original }} - </template>
                                            {{ child.pro_name_site }}
                                        </a>
                                    </h1>
                                </span>
                            </td>
                            <td class="pb-2 pt-0"></td>
                            <td class="pb-2 pt-0">{{ child.qtd_cart }}</td>
                            <td v-if="hasFractionalSale" class="pb-2 pt-0"></td>
                            <td class="pb-2 pt-0"></td>
                        </tr>
                    </template>
                </template>

                <!-- LISTAGEM DE PRODUTOS COM ADICIONAIS -->
                <template v-for="(item, key) in listCartWithAdditionalProducts">
                    <tr :key="key+'-'+item.uuid" class="product-row">
                        {{ setBackup(item) }}
                        <td class="product-col">
                            <CartItemProduct
                                :product="item"
                            />
                        </td>
                        <td>
                            {{ !item.price_to ? currency.money(item.pro_price_site) : currency.money(item.price_to) }}
                        </td>
                        <td>
                            <template v-if="page == 'checkout'">
                                {{ item.qtd_cart }}
                                <template v-if="getShowUnitOfMeasureInProductPrice">
                                    {{ item.pro_sigla_medida }}
                                </template>
                            </template>
                            <template v-else>
                                <c-input-qtd style="margin: 0 auto" class="input-quantity-cart">
                                    <input
                                        type="text"
                                        v-model="item.qtd_cart"
                                        :disabled="item.quantity_per_box && item.discount_when_selling_with_closed_box ? 'disabled' : false"
                                        @blur="onBlurMinimumQuantity(item, item.qtd_cart)"
                                    >
                                    <div class="buttons-quantity-cart">
                                        <button
                                            class="btn-quantity-plus"
                                            @click="setQuantityPlus(item)"
                                        >
                                            <i class="fas fa-caret-up"></i>
                                        </button>
                                        <button
                                            class="btn-quantity-minus"
                                            @click="setQuantityMinus(item)"
                                        >
                                            <i class="fas fa-caret-down"></i>
                                        </button>
                                    </div>
                                    <span v-if="getShowUnitOfMeasureInProductPrice" style="align-self: center; margin-left: 0.5rem">
                                        {{ item.pro_sigla_medida }}
                                    </span>
                                </c-input-qtd>
                            </template>
                        </td>
                        <td v-if="hasFractionalSale">
                            {{ item.fractional_quantity }} {{ item.fractional_label }}
                        </td>
                        <td v-if="calculateIpi">
                                {{ item.ipi_percentage }}%
                        </td>
                        <td>
                            {{currency.money(calculateSubTotal(item))}}
                        </td>
                    </tr>
                    <tr v-if="page != 'checkout'" :key="key+'-2-'+item.uuid" class="product-action-row">
                        <td :colspan="5" class="clearfix p-0">

                            <div class="float-right">
                                <a
                                    href="#"
                                    @click.prevent.stop="removeItem(item.id, item.key_cart)"
                                    title="Remover produto"
                                    class="btn-remove"
                                >
                                    <span class="sr-only">Remover</span>
                                </a>
                            </div>
                        </td>
                    </tr>

                    <template v-for="(additional, index) in item.additional_products[0]">
                        <tr :key="key+'-'+index+'-'+item.uuid+'-'+additional.uuid">
                            <td class="d-flex align-items-center pb-2 pt-0">
                                <figure class="product-image-container mr-4" style="min-width: 8rem; width: 8rem;  margin: 0 0 0 8.4rem">
                                    <a
                                        :href="item.url_pro"
                                        class="product-image"
                                    >
                                        <vue-load-image>
                                            <img slot="image" :src="additional.image_main" :title="additional.pro_name_site" :alt="additional.pro_name_site">
                                            <img slot="preloader" :src="$baseUrl+'assets/images/loading-image.gif'"/>
                                            <div slot="error">Erro ao carregar a imagem</div>
                                        </vue-load-image>
                                    </a>
                                </figure>
                                <span class="text-left">
                                    <h1>
                                        <a :href="item.url_pro">
                                            <template v-if="products_settings.show_code_original_beside_description == true && additional.api_cod_original">{{ additional.api_cod_original }} - </template>
                                            {{ additional.pro_name_site }}
                                        </a>
                                    </h1>
                                </span>
                            </td>
                            <td class="pb-2 pt-0">{{ currency.money(additional.pro_price_site) }}</td>
                            <td class="pb-2 pt-0">{{ additional.qtd_cart }}</td>
                            <td v-if="hasFractionalSale" class="pb-2 pt-0"></td>
                            <td v-if="calculateIpi">
                                {{ item.ipi_percentage }}%
                            </td>
                            <td class="pb-2 pt-0">{{ currency.money(calculateSubTotal(additional)) }}</td>
                        </tr>
                    </template>
                </template>
            </tbody>
            <tfoot>
                <slot name="footer"></slot>
            </tfoot>
        </table>
        <span class="purchase-message" v-if="page == 'checkout' && settings && settings.purchase_message">{{ settings.purchase_message }}</span>
    </cart-table-container>
</template>

<script>
import { CCartTableContainer, CInputQtd } from './Styles/Template/styled'
import Currency from '../helpers/parseCurrency'
import { mapActions, mapGetters, mapState } from 'vuex'
import VueLoadImage from 'vue-load-image'
import LoadingApp from './LoadingApp.vue'
import { CSpan } from './Styles/Components/styled'
import CartItemProduct from '../pages/cart/CartItemProduct'

export default {
    name: 'CartTableProducts',
    props: {
        page: {
            default: 'cart'
        },
        products_settings: {
            required: true
        }
    },
    components: {
        LoadingApp,
        CartItemProduct,
        'vue-load-image': VueLoadImage,
        'cart-table-container': CCartTableContainer,
        'c-input-qtd': CInputQtd,
        'c-span': CSpan,
    },
    data() {
        return {
            isLoading: false,
            currency: Currency,
            settings: this.$root.$children[0].$attrs.company?.settings ?? null,
            textTransform: this.$root.$children[0].theme?.products?.product_page?.text_transform_title ?? '',
            backupCart: [],
        }
    },
    methods: {
        ...mapActions("shipping", [
            "ActionSetShippingMethodState"
        ]),
        ...mapActions("cart", [
            "ActionRemoveItemCart",
            "ActionUpdateItemCart",
            "ActionSetItemsCart",
            "ActionDestroyCart",
            "ActionRemoveProductGroup"
        ]),
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        alertToast(msg = null, icon = "exclamation", theme = 'warning', timer = 4) {
            this.setThemeToast(theme)
            this.setMessageToast(msg)
            this.setIconToast(icon)
            this.setTimerToast(timer)
            this.setShowToast(true)
            setTimeout(() => {
                this.setShowToast(false)
            }, (timer * 1000));
        },
        setNumberOfBoxesSelected(item) {
            return item.qtd_cart / item.quantity_per_box
        },
        calculateSubTotal(item) {
            let price = !item.price_to ? parseFloat(item.pro_price_site) : parseFloat(item.price_to)
            if(this.calculateIpi) {
                return (price + price * item.ipi_percentage/100) * item.qtd_cart
            } else {
                return price * item.qtd_cart
            }
        },
        setQuantityMinus(item) {
            let qtd = Number(item.qtd_cart)
            let min = Number(item?.quantity_conversion_factor > item.minimum_sale_quantity ? item.quantity_conversion_factor : item.minimum_sale_quantity)

            if(item.quantity_per_box && item.discount_when_selling_with_closed_box) {
                qtd -= item.quantity_per_box
                if(qtd < 2 || qtd < min) {
                    this.alertToast(`Este produto possui quantidade mínima de ${min} ${item.pro_sigla_medida}`)
                    return
                }
                this.data = {
                    pro_id: item.id,
                    key: item.key_cart,
                    qtd: qtd,
                    action: 'decrement',
                    color_id: item.color_id_cart,
                    size_id: item.size_id,
                    items_grid_id: item.items_grid_id,
                }
                this.backupCart.find(el => el.id == item.id).qtd_cart = qtd
                this.updateCart()
                return
            }

            if(qtd < 2 || qtd <= min) {
                this.alertToast(`Este produto possui quantidade mínima de ${min} ${item.pro_sigla_medida}`)
                qtd = min
                return
            }
            let resto = Number(qtd) % Number(item.quantity_conversion_factor)
            let qtdSobra = resto == 0 ? Number(item.quantity_conversion_factor) - resto : resto
            let qtdAdd = Number(qtd) - qtdSobra
            qtd = qtdAdd < Number(min) ? Number(min) : qtdAdd

            this.data = {
                pro_id: item.id,
                key: item.key_cart,
                qtd: qtd,
                action: 'decrement',
                color_id: item.color_id_cart,
                size_id: item.size_id,
                items_grid_id: item.items_grid_id,
            }
            this.backupCart.find(el => el.id == item.id).qtd_cart = qtd
            this.updateCart()
        },
        validateMaximumPurchaseAmountByUser(item) {
            let priceMaxPurchase = Number(this.client?.maximum_purchase_amount)
            let cartTotalAmount = Number(this.itemsCart?.totalAmount)
            let purchasePrice = Number(item.pro_price_site) + cartTotalAmount

            if(purchasePrice == priceMaxPurchase) {
                return false
            }

            if(cartTotalAmount > priceMaxPurchase || purchasePrice > priceMaxPurchase) {
                this.alertToast("Valor máximo de compra atingido!")
                return true
            }
            return false
        },
        setQuantityPlus(item) {
            let qtd = Number(item.qtd_cart)
            let max = item?.maximum_sale_quantity

            if(this.client?.maximum_purchase_amount && this.client.maximum_purchase_amount > 0 && this.validateMaximumPurchaseAmountByUser(item)) {
                return
            }

            if(item.quantity_per_box && item.discount_when_selling_with_closed_box) {
                qtd += item.quantity_per_box
                if(max && qtd >= max) {
                    this.alertToast(`Quantidade máxima atingida para este produto.`)
                    return
                }
                this.data = {
                    pro_id: item.id,
                    key: item.key_cart,
                    qtd: qtd,
                    action: 'increment',
                    color_id: item.color_id_cart,
                    size_id: item.size_id,
                    items_grid_id: item.items_grid_id,
                }
                this.backupCart.find(el => el.id == item.id).qtd_cart = qtd
                this.updateCart()
                return
            }

            if(max && qtd >= max) {
                this.alertToast(`Quantidade máxima atingida para este produto.`)
                return
            }
            let resto = Number(qtd) % Number(item.quantity_conversion_factor)
            let qtdFalta = Number(item.quantity_conversion_factor) - resto
            if(max && (qtdFalta + Number(qtd)) > Number(max)) {
                this.alertToast(`Quantidade máxima atingida para este produto.`)
                qtd = Number(max)
                return
            }
            qtd = qtdFalta + Number(qtd)

            this.data = {
                pro_id: item.id,
                key: item.key_cart,
                qtd: qtd,
                action: 'increment',
                color_id: item.color_id_cart,
                size_id: item.size_id,
                items_grid_id: item.items_grid_id,
            }
            this.backupCart.find(el => el.id == item.id).qtd_cart = qtd
            this.updateCart()
        },
        onBlurMinimumQuantity(item, qtd) {
            let quantity = qtd
            let min = Number(item?.quantity_conversion_factor > item.minimum_sale_quantity ? item.quantity_conversion_factor : item.minimum_sale_quantity)
            let max = item?.maximum_sale_quantity

            if(this.client?.maximum_purchase_amount && this.client.maximum_purchase_amount > 0) {
                if(Number(quantity) > Number(this.backupCart.find(el => el.id == item.id).qtd_cart)) {
                    let priceMaxPurchase = Number(this.client?.maximum_purchase_amount)
                    let cartTotalAmount = Number(this.itemsCart?.totalAmount)
                    let purchasePrice = (Number(quantity) * Number(item.pro_price_site))
                    let oldProduct = Number(this.backupCart.find(el => el.id == item.id).qtd_cart) * Number(item.pro_price_site)

                    if(cartTotalAmount > priceMaxPurchase || (purchasePrice - oldProduct) > (priceMaxPurchase - cartTotalAmount)) {
                        let availableQuantity = (priceMaxPurchase - cartTotalAmount).toFixed(2)
                        if(availableQuantity > 0) {
                            this.alertToast(`Seu limite restante é de ${this.currency.money(availableQuantity)} em compras!`)
                        } else {
                            this.alertToast("Valor máximo de compra atingido!")
                        }
                        quantity = this.backupCart.find(el => el.id == item.id).qtd_cart
                    }
                }
            }

            if(Number(quantity) < Number(min)) {
                this.alertToast(`Este produto possui quantidade mínima de ${min} ${item.pro_sigla_medida}`)
                item.qtd_cart = Number(min)
                quantity = Number(min)
                this.data = {
                    pro_id: item.id,
                    key: item.key_cart,
                    qtd: quantity,
                    action: 'setQtd',
                    color_id: item.color_id_cart,
                    size_id: item.size_id,
                    items_grid_id: item.items_grid_id,
                }
                this.backupCart.find(el => el.id == item.id).qtd_cart = quantity
                this.updateCart()
                return
            }
            let resto = Number(quantity) % Number(item.quantity_conversion_factor)
            let qtdFalta = Number(item.quantity_conversion_factor) - resto
            let qtdSobra = resto == 0 ? Number(item.quantity_conversion_factor) - resto : resto

            if(max && Number(quantity) >= Number(max) && !item.color_id && !item.size_id) {
                if(Number(quantity) > max) {
                    this.alertToast(`Este produto possui quantidade máxima de ${max} ${item.pro_sigla_medida}`)
                    item.qtd_cart -= Number(qtdSobra)
                    quantity -= Number(qtdSobra)
                    return
                }
                if(qtdSobra != Number(item.quantity_conversion_factor)) {
                    this.alertToast(`Quantidade máxima atingida.`)
                    item.qtd_cart -= Number(qtdSobra)
                    quantity -= Number(qtdSobra)
                    return
                }
                this.data = {
                    pro_id: item.id,
                    key: item.key_cart,
                    qtd: quantity,
                    action: 'setQtd',
                    color_id: item.color_id_cart,
                    size_id: item.size_id,
                    items_grid_id: item.items_grid_id,
                }
                this.backupCart.find(el => el.id == item.id).qtd_cart = quantity
                this.updateCart()
                return
            }
            if(resto != 0) {
                if(qtdFalta <= qtdSobra) {
                    quantity = qtdFalta + Number(quantity)
                } else {
                    quantity = Number(quantity) - qtdSobra
                }
            }
            this.data = {
                pro_id: item.id,
                key: item.key_cart,
                qtd: quantity,
                action: 'setQtd',
                color_id: item.color_id_cart,
                size_id: item.size_id,
                items_grid_id: item.items_grid_id,
            }
            this.backupCart.find(el => el.id == item.id).qtd_cart = quantity
            this.updateCart()
        },
        async updateCart() {
            this.isLoading = true
            await this.ActionUpdateItemCart(this.data)
            .then((response) => {
                this.isLoading = false
                let { data } = response
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                this.isLoading = false
                const { data } = error
                if(data?.list.length) {
                    let qtdPrev = data.list.find(el => {
                        if((el.id == data.id && el.color_id_cart == data.color_id && el.size_id == data.size_id)) {
                            return el
                        }
                    }).qtd_cart
                    this.itemsCart.list.find(el => {
                        if((el.id == data.id && el.color_id_cart == data.color_id && el.size_id == data.size_id)) {
                            return el
                        }
                    }).qtd_cart = qtdPrev
                }
                this.alertToast(error?.msg ?? error)
            })
        },
        removeProductGroup(id, children) {
            let children_uuids = []
            for (const i in children) {
                if (Object.hasOwnProperty.call(children, i)) {
                    const element = children[i];
                    children_uuids.push(element.uuid)
                }
            }
            let body = {
                father_uuid: id,
                children_uuids
            }
            this.ActionRemoveProductGroup(body)
             .then((resp) => {
                let {data} = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },
        async removeItem(pro_id, index) {
            this.isLoading = true
            let data = {
                pro_id: pro_id,
                key: index
            }
            await this.ActionRemoveItemCart(data)
            .then((resp) => {
                this.isLoading = false
                let {data} = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                this.isLoading = false
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },
        setBackup(item) {
            if(this.backupCart.find(el => el.id == item.id)) {
                return
            }
            this.backupCart.push({id: item.id, qtd_cart: item.qtd_cart})
        },
        fileNotImage(file_name) {
            return (file_name.search(/.+\.pdf$/) >= 0 || file_name.search(/.+\.cdr$/) >= 0 || file_name.search(/.+\.psd$/) >= 0)
        }
    },
    watch: {
        itemsCart(data) {
            if(!data) {
                return
            }
            this.ActionSetShippingMethodState(data.shippingMethod)
            data.list.forEach(element => {
                element.pro_name_site = this.textTransform == 'uppercase' ? element.pro_name_site.toUpperCase() :
                    this.textTransform == 'lowercase' ? element.pro_name_site.toLowerCase() :
                    this.textTransform == 'initial' ? (element.pro_name_site[0].toUpperCase() + element.pro_name_site.substr(1).toLowerCase()) :
                    this.textTransform == 'capitalize' ? (element.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })): element.pro_name_site
            });
        },
    },
    computed: {
        ...mapState("cart", [
            "itemsCart",
        ]),
        ...mapGetters("cart", [
            "listCartWithAdditionalProducts",
            "containsAdditionalProductsInCart"
        ]),
        ...mapGetters("company", [
            "getShowUnitOfMeasureInProductPrice"
        ]),
        ...mapState("clients", ["client"]),
        hasFractionalSale() {
            return this.itemsCart?.list?.some(i => i.fractional_sale);
        },
        calculateIpi() {
            return this.$root.$children[0].$attrs.company?.settings?.calculate_ipi ?? false
        }
    }
}
</script>

<style lang="scss" scoped>
/* .cart__flavor + .cart__flavor::before {
    content: ' / ';
} */
.line-table-additional {
    display: flex;

    td {
        display: flex;
        align-items: center;

        figure {
            min-width: 8rem;
            width: 8rem;
            display: flex;
            margin-right: 1rem;
        }

        .additional-product-observation {
            margin-bottom: 1rem;
            text-align: start;
        }
    }

    &.pdf-additional {
        td {
            flex-direction: column;
            align-items: flex-start;

            figure {
                min-width: 1px;
                width: auto;
            }
        }
    }

    @media (max-width: 767px) {
        flex-direction: column;
        justify-content: center;
        text-align: center;

        td {
            flex-direction: column;

            figure {
                min-width: 1px;
                width: auto;
                display: flex;
                justify-content: center;
                margin-right: 0;
            }

            .additional-product-observation {
                text-align: center;
            }
        }

        &.pdf-additional {
            td {
                flex-direction: column;
                align-items: center;

                figure {
                    min-width: 1px;
                    width: auto;
                }
            }
        }
    }
}
</style>
